<template>
  <div class="em-order">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <f-date-range-picker v-model="query.createtime" :shortcuts="[0, -7, -30, -90, -180, -360]"
            @change="fetchData(1)" />
        </div>
        <div class="filter-item">
          <f-member-selector v-model="query.memberid" @change="fetchData(1)" />
        </div>
        <div class="filter-item">
          <el-select v-model="query.pay_status" placeholder="支付状态" clearable filterable style="width: 160px;" @change="fetchData(1)">
            <el-option v-for="item in payStatus" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item">
          <el-select v-model="query.shipping_status" placeholder="发货状态" clearable filterable style="width: 160px;"
            @change="fetchData(1)">
            <el-option v-for="item in shippingStatus" :key="item.value" :label="item.title" :value="item.value" />
          </el-select>
        </div>
        <div class="filter-item" style="width: 200px;">
          <el-input v-model="query.keyword" placeholder="订单编号 / 标题 / 备注" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
        </div>
      </div>
      <div class="toolbox">
        <el-button icon="el-icon-plus" type="success" @click="$router.push('/em/order/create')">新建订单</el-button>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never" class="mb-md" style="margin-bottom: 65px;">
      <el-table :data="list">
        <el-table-column type="index" label="#" />

        <el-table-column prop="order_sn" label="订单编号" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span style="color: #303133;font-size: 14px;">{{ scope.row.order_sn }}</span>
          </template>
        </el-table-column>

        <el-table-column width="60">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.buyer_avatar" shape="rounded" />
          </template>
        </el-table-column>
        <el-table-column label="用户" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <f-user-name :user="{ nickname: scope.row.buyer_nickname, memberid: scope.row.memberid }" />
          </template>
        </el-table-column>
        <el-table-column prop="subject" label="订单主题" min-width="150" show-overflow-tooltip />
        <el-table-column label="订单金额" min-width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.total_price | currency }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态/完成时间" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.pay_status === 1">{{ scope.row.pay_time | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
            <el-tag v-else-if="scope.row.pay_status === 0" type="danger">待支付</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发货状态/签收时间" min-width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.shipping_status === 3">{{ scope.row.shipping_time | parseTime('{y}/{m}/{d} {h}:{i}')
            }}</span>
            <el-tag v-else-if="scope.row.shipping_status === 1" type="warning">已发货</el-tag>
            <el-tag v-else-if="scope.row.shipping_status === 0" type="danger">待发货</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="60">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.remark" popper-class="prm-clue-tooltip-description" placement="top">
              <template slot="content">
                <el-scrollbar style="max-height: 400px;">
                  <div class="prm-clue-tooltip-description-content">
                    {{ scope.row.remark }}
                  </div>
                </el-scrollbar>
              </template>
              <i class="el-icon-chat-dot-round font-2x text-muted"></i>
            </el-tooltip>
          </template>
        </el-table-column>


        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="openDrawer(scope.row)">详情</el-button>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </template>
      </el-table>
    </el-card>

    <f-table-footer v-if="list.length" :list="list" class="main-footer-fix" style="padding-left: 38px">
      <template slot="right">
        <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
      </template>
    </f-table-footer>
    <order-detail-drawer :show.sync="drawerVisible" :orderid="currentOrderid" @close="closeDrawer" />
  </div>
</template>

<script>
import {
  getGodProductOrderListApi
} from '@/api/ei/eiMallApi'

export default {
  name: "EmOrder",

  components: {
    OrderDetailDrawer: () => import('./components/OrderDetailDrawer')
  },

  data() {
    return {
      loading: false,
      total: 0,
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        memberid: null,
        keyword: '',
        createtime: null,
        pay_status: null
      },
      payStatus: [
        { value: 0, title: "待支付" },
        { value: 1, title: "已支付" },
      ],
      shippingStatus: [
        { value: 0, title: "待发货" },
        { value: 1, title: "已发货" },
        { value: 3, title: '已签收' }
      ],
      list: [],
      drawerVisible: false,
      currentOrderid: null,
    };
  },

  created() {
    this.fetchData()
  },

  computed: {},

  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page;
      this.loading = true;
      getGodProductOrderListApi(this.query).then(res => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      })
    },

    toDetail(memberid) {
      this.$memberdetail({ memberid })
    },
    openDrawer(row) {
      this.currentOrderid = row.orderid;
      this.drawerVisible = true;
    },
    closeDrawer() {
      this.drawerVisible = false;
      this.currentOrderid = null;
      this.fetchData()
    },

  },
};
</script>
